export const EMPLOYED_FULL = 'employed-full';
export const EMPLOYED_PART = 'employed-part';
export const SIDEJOB = 'sidejob';
export const MINORJOB = 'minorjob';
export const TRAINEESHIP = 'traineeship';
export const INTERNSHIP = 'internship';
export const THESIS = 'thesis';
export const FREELANCE = 'freelance';
export const HONORARY = 'honorary';
export const BROKERAGE = 'brokerage';
export const FRANCHISE = 'franchise';
export const PARTICIPATION = 'participation';

export const FREELANCE_HOURLY = 'hourly';
export const FREELANCE_FLAT = 'flat';